export default __webpack_public_path__ + "static/kopiika-746cd1af8c084b935515c2a21b191f12.svg";